import React, { useEffect, useState } from "react";
import "./Invoices.css";
import InvoiceLogo from "../../images/qcr-logo-b.png";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { GetInvoiceDetail } from "../../apis/InvoiceAPI";
import dateFormat from "dateformat";

export default function ViewInvoice() {
  const [searchParams] = useSearchParams();
  const invoiceid = searchParams.get("invoiceid");
  const customerid = searchParams.get("customerid");

  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const [tax, setTax] = useState(0);
  const [taxType, setTaxType] = useState("");
  const [amountDue, setAmountDue] = useState(0);
  const [subsType, setSubsType] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [miscData, setMiscData] = useState([]);
  const [fee, setFee] = useState(0);

  useEffect(() => {
    async function InvoiceDetail() {
      var result = await GetInvoiceDetail(customerid, invoiceid);
      var invData = result.data.item1;
      setInvoiceData(invData);
      let gst = invData.customer_gst_exempt;
      setInvoiceAmount(invData.invoice_amount.toFixed(2));
      setSubsType(invData.customer_subs_type == "0" ? false : true);
      if (invData.customer_subs_type == "0") {
        setReportData(result.data.item2);
        setMiscData(result.data.item3);
      }
      if (gst != "1") {
        let tx = parseFloat(invData.tax_percentage);
        let amt = parseFloat(invData.invoice_amount);
        let service = parseFloat(invData.service_fee);
        let srvc_fee = amt * (service / 100);
        let txValue = (amt + srvc_fee) * (tx / 100);
        let total =
          parseFloat(srvc_fee) + parseFloat(txValue) + parseFloat(amt);
        setTax(txValue.toFixed(2));
        setFee(srvc_fee.toFixed(2));
        setTaxType(invData.tax_type);
        setAmountDue(total.toFixed(2));
      } else {
        setTax(0.0);
        setTaxType("GST Exempt");
        setAmountDue(invData.invoice_amount);
      }
    }
    InvoiceDetail();
  }, []);
  return (
    <>
      <Container id="ViewInvoiceBg">
        <Row className="justify-content-center mt-5">
          <Col xl={8} lg={10} md={12}>
            <div className="view-invoice">
              <div className="receipt-content">
                <div className="invoice-wrapper">
                  <div className="invoice-logo">
                    <img src={InvoiceLogo} alt="QCR" width={200} />
                    <small>
                      80F Centurian Drive, Unit 210 Markham, ON. L3R 8C1
                    </small>
                  </div>
                  <div className="intro">
                    <div className="row">
                      <div className="col-sm-6">
                        {invoiceData.billing_entity_name ? (
                          <p className="intro-name">
                            {invoiceData.billing_entity_name}
                          </p>
                        ) : (
                          ""
                        )}
                        <p
                          className={
                            invoiceData.billing_entity_name
                              ? "intro-add"
                              : "intro-name"
                          }
                        >
                          {invoiceData.customer_first_name}
                        </p>
                        <p className="intro-add">
                          {invoiceData.requestor_street_address},<br />
                          {invoiceData.requestor_street_address_2 && (
                            <>
                              {invoiceData.requestor_street_address_2},
                              <br />
                            </>
                          )}
                          {invoiceData.requestor_city},{" "}
                          {invoiceData.abbreviation}{" "}
                          {invoiceData.requestor_zip_code}
                        </p>
                        <p className="intro-requestor">
                          <strong>Requestor Name:</strong>{" "}
                          {invoiceData.requestor_first_name}
                        </p>
                      </div>
                      <div className="col-sm-6 text-right">
                        <div className="intro-table">
                          <Table bordered>
                            <thead>
                              <tr>
                                <th>INVOICE NO.</th>
                                <th>DATE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{invoiceData.invoice_id}</td>
                                <td>
                                  {dateFormat(
                                    invoiceData.batch_date,
                                    "mm/dd/yyyy"
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="payment-info">
                    <div className="payment-table">
                      <Table bordered>
                        <thead>
                          {subsType ? (
                            <tr>
                              <th>CUSTOMER NO.</th>
                              <th>TERMS</th>
                              <th>PAGE NO.</th>
                            </tr>
                          ) : (
                            <tr>
                              <th>RE/PO</th>
                              <th>CUSTOMER NO.</th>
                              <th>TERMS</th>
                              <th>{"\u00A0"}</th>
                              <th>PAGE NO.</th>
                            </tr>
                          )}
                        </thead>
                        <tbody>
                          {subsType ? (
                            <tr>
                              <td>{invoiceData.customer_id}</td>
                              <td>Payment Due Upon Receipt</td>
                              <td>1</td>
                            </tr>
                          ) : (
                            <tr>
                              <td>{invoiceData.order_po}</td>
                              <td>{invoiceData.customer_id}</td>
                              <td>Payment Due Upon Receipt</td>
                              <td>{"\u00A0"}</td>
                              <td>1</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  <div className="line-items">
                    <div className="list-items-table">
                      <Table>
                        <thead>
                          {subsType ? (
                            <tr>
                              <th>CONTRACT</th>
                              <th>START DATE</th>
                              <th>TYPE</th>
                              <th>RATE</th>
                              <th>TOTAL</th>
                            </tr>
                          ) : (
                            <tr>
                              <th>REQUESTOR</th>
                              <th>
                                START
                                <br />
                                DATE
                              </th>
                              <th>APPLICANT/CO-APPLICANT/REPORT</th>
                              <th>RATE</th>
                              <th>TOTAL</th>
                              <th>COMPLETE</th>
                            </tr>
                          )}
                        </thead>
                        <tbody>
                          {subsType ? (
                            <tr>
                              <td>{invoiceData.contract_id}</td>
                              <td>
                                {dateFormat(
                                  invoiceData.contract_start_date,
                                  "mm/dd/yyyy"
                                )}
                              </td>
                              <td>Contract</td>
                              <td>${invoiceAmount}</td>
                              <td>${invoiceAmount}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td>{invoiceData.requestor_first_name}</td>
                              <td>
                                {dateFormat(
                                  invoiceData.order_start_date,
                                  "mm/dd/yyyy"
                                )}
                              </td>
                              <td>
                                {invoiceData.order_applicant_name}
                                {invoiceData.order_co_applicant
                                  ? "/" + invoiceData.order_co_applicant
                                  : ""}{" "}
                                <br />
                                {reportData.map((rpt) => (
                                  <>
                                    {rpt.report_name + " - " + rpt.reportprice}
                                    <br />
                                  </>
                                ))}{" "}
                                <br />
                                {miscData.map((misc) => (
                                  <>
                                    {misc.misc_note + " - " + misc.misc_price}
                                    <br />
                                  </>
                                ))}
                              </td>
                              <td>${invoiceAmount}</td>
                              <td>${invoiceAmount}</td>
                              <td>
                                {dateFormat(
                                  invoiceData.order_completed_date,
                                  "mm/dd/yyyy"
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div className="invoice-total">
                      <Table>
                        <tbody>
                          <tr>
                            <td>
                              <p className="invoice-total-gst">
                                GST / HST #R133870931
                              </p>
                              <p className="invoice-total-add">
                                <strong>Make Cheque Payable to:</strong>
                                <br />
                                Quality Credit Services Ltd.
                                <br />
                                80F Centurian Drive, Unit 210
                                <br />
                                Markham, Ontario
                                <br />
                                L3R 8C1
                              </p>
                            </td>
                            <td>
                              <Table bordered>
                                <tbody>
                                  <tr>
                                    <th>Sub Total</th>
                                    <td>${invoiceAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Service Fee</th>
                                    <td>${fee}</td>
                                  </tr>
                                  <tr>
                                    <th>{taxType}</th>
                                    <td>${tax}</td>
                                  </tr>
                                  <tr>
                                    <th>Amount Due</th>
                                    <td>${amountDue}</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
